import * as React from 'react';

// MATERIAL UI IMPORTS
import {
  Dialog,
  IconButton,
  Typography,
  DialogTitle,
  Container
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

//CUSTOM IMPORTS
import FormPeqProveedor from '../../../proveedores/nueva_version/pequeños_proveedores/abm/FormPeqProveedor';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from "@mui/icons-material/Search"

export default function DialogoNuevoProveedor(props) {

  /* ---------------------------- STYLING ----------------------------- */
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    background: "linear-gradient(135deg, #164e63 0%, #0c3a47 100%)",
    color: "#ffffff",
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    "& .MuiTypography-root": {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      fontSize: "1.25rem",
      fontWeight: 450,
    },
  }))

  /* ---------------------------- RENDER ----------------------------- */
  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={props.open}
        onClose={props.handleCloseAddProveedor}
        // TransitionComponent={Transition}
        PaperProps={{
          sx: {
            boxShadow: "0 20px 60px rgba(22, 78, 99, 0.15)",
          },
        }}
      >
        <StyledDialogTitle>
          <Typography component="div">
            <SearchIcon sx={{ fontSize: "28px" }} />
            Añadir pequeño proveedor
          </Typography>
          <IconButton
            onClick={props.handleCloseAddProveedor}
            sx={{
              color: "#ffffff",
              "&:hover": {
                backgroundColor: alpha("#ffffff", 0.1),
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <Container sx={{ p: 3 }}>
          <FormPeqProveedor handleCloseAddProveedor={props.handleCloseAddProveedor} />
        </Container>
      </Dialog>
    </React.Fragment>
  );
}
